import fetch from '../utils/Api'
import {
  SLIDER_HOME,
  SLIDER_ITEM_CLICK
} from '../constants'

export const sliderBanner = (payload) => ({
  type: SLIDER_HOME,
  payload: fetch().get('sliders', payload).then(res => res.data)
});

export const sliderItemClick = (payload) => ({
  type: SLIDER_ITEM_CLICK,
  payload: fetch().post('/sliders/activity', payload).then(res => res.data)
});

